export default __webpack_public_path__ + "static/media/content-image_board-of-directors.bded582c.png";